import React from 'react';
import style from './index.module.scss';

const NmckMedicinesCalculationInfo: React.FC = () => (
  <>
    <h1 className={style.header}>Расчет НМЦК на лекарственные препараты</h1>
    <div className={style.description}>
      <h2 className={style.descriptionTitle}>Сервис позволяет:</h2>

      <div className={style.descriptionItems}>
        <div className={style.descriptionItem}>
          Обосновать размер НМЦК на лекарственные препараты с применением нескольких методов расчета, чтобы избежать
          жалоб участников, штрафов (до 10 000 руб.) и признания закупки несостоявшейся.
        </div>
      </div>
    </div>
  </>
);

export default NmckMedicinesCalculationInfo;
